<template>
  <div>
    <div class="page-head">
      <div>
        <h3>Search &amp; Order</h3>
        <p class="page-head-sub">Find parts in stock, sell them or order from suppliers</p>
      </div>
    </div>
    <b-modal id="success" hide-header hide-footer body-text-variant="dark">
      <template class="bg-success" #modal-title>
        Info
      </template>
      <div class="d-block text-center p-4">
        <h3>Successfully saved.</h3>
      </div>
      <b-button variant="primary" class="mt-3 px-4 float-right" @click="$bvModal.hide('success')">OK</b-button>
    </b-modal>
    <div class="position-fixed col-xl-5 col-lg-7 col-md-9 col-sm-12" style="right: 0; top: 0; z-index: 1040;">
      <div v-if="holdOn" class="hold-on"></div>
      <b-card class="rounded korpa" v-if="Object.keys(order).length">
        <ul class="list-group mb-3">
          <li class="list-group-item" v-for="(val, key) of order" v-bind:key="val.sku">
            <div class="row">
              <div class="col-6">
                <b-icon @click="reduceCount(key)" class="mr-2 remove-icon" icon="trash" variant="danger"></b-icon> <strong>{{key}}</strong>
              </div>
              <div class="col-3 text-center">
                <input class="col-12 border-0" v-model.number="val.price" type="number" step="0.01" inputmode="decimal">
              </div>
              <div class="col-3 text-left">
                x{{val.count}} = <strong class="float-right">{{ val.count*val.price }}kr</strong>
              </div>
            </div>
          </li>
        </ul>
        <b-button @click="otkazi" variant="danger" class="m-1">
          <b-icon class="mr-2 remove-icon" icon="trash" variant="light"></b-icon>
        </b-button>
        <b-button v-if="user && user.admin" @click="storeOrder" variant="success" class="float-right">
          <strong> {{totalCart.toLocaleString()}}kr </strong>
          <b-icon-bag></b-icon-bag>
        </b-button>
        <b-button @click="exportArticles" variant="primary" class="float-right mr-2">EXPORT
          <b-icon-file-plus></b-icon-file-plus>
        </b-button>
      </b-card>
    </div>
    <div class="form-card px-2 pb-3">
    <b-row class="mx-0">
      <b-col sm="4" class="mt-2">
        <b-form-input size="lg" class="pretraga text-uppercase" v-model="code"
                      type="text"
                      v-on:keyup.enter="search"
                      :placeholder="`ENTER ${inputType} TO SEARCH FOR`">
        </b-form-input>
      </b-col>
      <b-col sm="4" class="mt-2">
<!--        REGISTERED CLIENTS INPUT -->
        <b-input-group v-if="registeredInput">
          <vue-typeahead-bootstrap
            id="name"
            size="lg"
            v-model="metaData"
            :data="clients"
            :serializer="client => client.name"
            append="Reset"
            ref="typeahead"
            @hit="clientId = $event._id">
            <template slot="append">
              <button @click="selectInput('regular')" class="btn btn-dark">
                <b-icon-people></b-icon-people>
              </button>
            </template>
          </vue-typeahead-bootstrap>
        </b-input-group>
<!--        REGULAR INPUT -->
        <b-input-group v-else>
          <b-form-input size="lg" :class="[isRegos ? 'bg-primary text-white' : '', 'pretraga']" v-model="metaData" type="text"></b-form-input>
          <b-input-group-append>
            <b-button @click="toggleRegos" variant="primary">R</b-button>
            <b-button @click="selectInput" variant="dark">
              <b-icon-person></b-icon-person>
            </b-button>
          </b-input-group-append>
        </b-input-group>

      </b-col>
      <b-col sm="2" class="mt-2">
        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            buttons
            button-variant="outline-secondary"
            class="w-100 segmented"
            id="radio-group-2"
            v-model="inputType"
            :aria-describedby="ariaDescribedby"
            name="radio-sub-component"
          >
            <b-form-radio :aria-describedby="ariaDescribedby" name="oem" value="oem">OEM</b-form-radio>
            <b-form-radio :aria-describedby="ariaDescribedby" name="sku" value="sku">SKU</b-form-radio>
            <b-form-radio :aria-describedby="ariaDescribedby" name="ean" value="ean">EAN</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="2" class="mt-2">
        <b-button @click="search" variant="primary" block size="lg"><b-icon-search class="mr-2"></b-icon-search>Search</b-button>
      </b-col>
    </b-row>
    </div>
    <div class="mt-4">
      <div class="text-center" v-if="loading">
        <b-icon icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
      <div v-else-if="!loading && articles.length" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>SKU</th>
            <th class="d-none d-sm-table-cell">Name</th>
<!--            <th class="d-none d-sm-table-cell">Fac. number</th>-->
            <th class="d-sm-table-cell">Stock</th>
            <th>Price</th>
            <th class="text-center">Location</th>
            <th class="text-center">Regos</th>
            <th class="d-none d-sm-table-cell text-center">Sell</th>
            <th class="d-none d-sm-table-cell text-center">Order</th>
            <th class="text-center"><b-icon-star></b-icon-star></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="article in articles" :key="article.codename" :style="`border-bottom: 6px solid ${getRowStyle(article)};`">
            <td v-b-tooltip.hover.left="`Sold: ${psLookup[article.codename] || 0}`"><b-badge v-if="refLookup[article.codename]" variant="primary">REF</b-badge> {{article.codename || 0}}</td>
            <td @click="showImage(article)" class="d-none d-sm-table-cell pointer">
              {{article.name || "No name"}}
            </td>
<!--            <td @click="selectedArticle = article" class="d-none d-sm-table-cell pointer">-->
<!--              {{getProductCode(article.productCodes.productCode) || "No part number"}}-->
<!--            </td>-->
            <td>{{article.localCount || 0}}</td>
            <td>{{article.productPrices.product_price.price.amount_with_vat || 0}}kr.</td>
            <td>{{article.localLocation || "No location"}}</td>
            <td class="text-center">
              <button @click="localToRegos(article.codename)" :disabled="!article.localCount" class="btn btn-outline-light"><b-icon-inbox></b-icon-inbox></button>
            </td>
            <td class="d-print-none d-none d-sm-table-cell text-center">
              <button v-if="article.localCount" @click="addToCart(article)" class="btn btn-outline-light">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-cart-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                  <path fill-rule="evenodd" d="M8.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V8H6.5a.5.5 0 0 1 0-1H8V5.5a.5.5 0 0 1 .5-.5z"/>
                </svg>
              </button>
              <button v-else class="btn btn-outline-light disabled">
                <b-icon-x></b-icon-x>
              </button>
            </td>
            <td class="d-none d-sm-table-cell text-center border-start" style="min-width: 130px">
              <b-icon-dash @click="decrementToOrder(article)" class="pointer"></b-icon-dash>
                {{inlineQ[article.codename] || 0}}
              <b-icon-plus @click="incrementToOrder(article)" class="pointer"></b-icon-plus>
              <button
                :disabled="!availableAtSupplier(article)"
                @click="orderArticle(article.codename, inlineQ[article.codename])"
                class="ml-2 btn btn-outline-light">
                <b-icon-download></b-icon-download>
              </button>
            </td>
            <td>
              <button @click="adjustFavorite(article)" class="ml-2 btn btn-outline-light">
                <span :class="favoriteLessThenLocal(article) && 'text-warning pulsing-number'">
                  {{article.favorite || 0}}
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <b-modal ref="image-modal" id="image-modal" hide-footer title="Product image">
        <div class="d-block text-center">
          <b-img :src="articleDetails.image" fluid alt="No image"></b-img>
        </div>
        <div class="border bg-light rounded text-dark flex-column">
          <p class="pt-3 pl-3"><strong>OEM codes: </strong>{{articleDetails.oems || 'No OEM codes for this product'}}</p>
        </div>
        <div class="mt-1 border bg-light rounded text-dark text-center flex-column">
          <p class="pt-3 pl-3"><a :href="articleDetails.link" target="_blank" rel="noopener noreferrer">View article on bdbildeler.no</a></p>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="$bvModal.hide('image-modal')">Close</b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import fixed from '../fixed';

const BASE_API_URL = fixed.API_URL;
const API_URL = `${fixed.API_URL}/admin`;

export default {
  name: 'LagerList',
  components: {
    VueTypeaheadBootstrap,
  },
  data: () => ({
    user: null,
    loading: false,
    holdOn: false,
    clients: [],
    inputType: 'oem',
    metaData: 'WORKSHOP',
    code: '',
    isRegos: false,
    registeredInput: false,
    clientId: null,
    order: {},
    articles: [],
    psLookup: {},
    to: null,
    inlineQ: {},
    articleDetails: {
      image: null,
      link: null,
      oems: [],
    },
    refLookup: {},
  }),
  created() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  async mounted() {
    // Get list of registered clients
    try {
      const { data: clients } = await axios.get(`${API_URL}/clients-list`, { withCredentials: true });
      this.clients = clients;

      if (this.$route.params.codename) {
        this.code = this.$route.params.codename;
        this.inputType = 'sku';
        await this.search();
      }
    } catch (err) {
      this.$toast.error('can\'t get registered clients');
    }
  },
  computed: {
    fixed() {
      return fixed;
    },
    totalCart() {
      return Object.values(this.order).reduce((acc, val) => acc + (val.count * val.price), 0);
    },
  },
  methods: {
    async search() {
      if (!this.code) return;
      const encodedEan = encodeURIComponent(this.code);

      const url = `${API_URL}/${this.inputType}2article?${this.inputType}=${encodedEan}`;
      const lookFor = [];
      this.loading = true;
      try {
        const { data } = await axios.get(url, { withCredentials: true });
        if (!data) {
          this.$toast.info('No articles with that code');
        } else {
          this.articles = Array.isArray(data) ? data : [data];
          // get articles to look for sold counts
          this.articles.forEach((article) => {
            lookFor.push(article.codename);
          });
          // fetch sold counts
          await this.getPreviouslySold(lookFor);
          await this.GetSameFromRefLager(this.articles);
          this.code = '';
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.error('you\'re not authorised for that action ✋🏻');
        } else {
          this.$toast.error(error?.response?.data || 'Error while fetching article from stock');
        }
        this.articles = [];
      }
      this.loading = false;
    },
    async getPreviouslySold(articles) {
      if (!articles || !articles.length) return;

      try {
        const { data } = await axios.get(`${BASE_API_URL}/previously-sold`, {
          withCredentials: true,
          params: {
            a: articles.join(','),
          },
        });
        if (!data || !data.length) {
          this.$toast('None of the articles sold in last 3 months');
          return;
        }

        this.psLookup = data.reduce((obj, item) => {
          obj[item._id] = (obj[item._id] || 0) + item.sold; // eslint-disable-line
          return obj;
        }, {});
      } catch (error) {
        alert(error); // eslint-disable-line
      }
    },
    selectInput(selected) {
      if (selected === 'regular') {
        this.registeredInput = false;
        this.metaData = 'WORKSHOP';
      } else {
        this.metaData = '';
        this.registeredInput = true;
        this.$nextTick(() => {
          this.preventPaste();
        });
      }
      this.clientId = null;
      this.isRegos = false;
    },
    async GetSameFromRefLager(kwikyArticles) {
      const skusToFetch = kwikyArticles.map((article) => article.codename);
      if (!skusToFetch.length) return;

      // URL with codenames as query param
      const url = `${API_URL}/ref-products-from-skus?p=${skusToFetch.join(',')}`;
      // reset refLookup before fetching new batch
      this.refLookup = {};

      this.loading = true;
      try {
        const resp = await axios.get(url, { withCredentials: true });
        if (resp?.data && resp.data.length) {
          resp.data.forEach((product) => {
            this.refLookup[product.kwikySKU] = true;
          });
        }
      } catch (error) {
        this.$toast.error(error?.response?.data || 'Error while fetching ref items');
      }
      this.loading = false;
    },
    availableAtSupplier(article) {
      if (!article?.supplies || !article.supplies?.supply || !article.supplies.supply.length) {
        return false;
      }
      let available = false;
      article.supplies.supply.forEach((supplier) => { // eslint-disable-line
        if (supplier.stock.availableCount > 0) available = true;
      });
      return available;
    },
    getRowStyle(article) {
      if (!article?.localCount) return '';

      const diff = moment().diff(moment(article.updatedAt), 'months', true);
      switch (true) {
        case diff <= 1:
          return 'green';
        case diff > 1 && diff <= 3:
          return 'yellow';
        case diff > 3 && diff <= 6:
          return 'orange';
        case diff > 6 && diff <= 12:
          return 'red';
        default:
          return 'purple';
      }
    },
    addToCart(artikal) {
      if (!artikal.localCount) return;

      if (!this.order[artikal.codename]) {
        this.$set(this.order, artikal.codename, {
          sku: artikal.codename,
          price: artikal.productPrices.product_price.price.amount_with_vat,
          stock: artikal.localCount,
          count: 1,
          num: this.getProductCode(artikal.productCodes.productCode),
        });
      } else {
        if (this.order[artikal.codename].count >= this.order[artikal.codename].stock) return;
        this.order[artikal.codename].count += 1;
      }
    },
    reduceCount(sku) {
      if (this.order[sku].count === 1) {
        this.order[sku] = null;
        delete this.order[sku];
      } else {
        this.order[sku].count -= 1;
      }
    },
    async storeOrder() {
      const payload = Object.values(this.order).map((val) => val);
      this.holdOn = true;
      try {
        await axios.post(`${API_URL}/create-order`, payload, { withCredentials: true });
        this.$bvModal.show('success');
        this.$router.push({ name: 'virtuals' });
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.holdOn = false;
      this.order = {};
    },
    async exportArticles() {
      const payload = Object.values(this.order).map((val) => val);
      this.holdOn = true;
      try {
        await axios.post(`${API_URL}/export-order`, payload, { withCredentials: true });
        this.$bvModal.show('success');
        this.$router.push({ name: 'virtuals' });
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.holdOn = false;
      this.order = {};
    },
    async orderArticle(sku, qtt) {
      if (qtt < 1 || !sku || !this.metaData) return;

      if (this.isRegos && !/^[0-9]+$/.test(this.metaData)) {
        this.$toast.error('regos ID has to be a number');
        return;
      }

      this.loading = true;
      try {
        const meta = this.isRegos ? `regos_${this.metaData}` : this.metaData;
        const { clientId } = this;
        await axios.post(`${API_URL}/poland-order`, {sku, qtt, meta, clientId}, { withCredentials: true }); // eslint-disable-line
        this.$toast.success('Article ordered successfully');
        this.inlineQ = {};
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          this.$toast.error(error.response.data || 'Error while creating order');
        }
      }
      this.loading = false;
    },
    async localToRegos(code) {
      if (!code || !this.metaData) return;

      if (!/^[0-9]+$/.test(this.metaData)) {
        this.$toast.error('regos ID has to be a number');
        return;
      }

      this.loading = true;
      try {
        await axios.post(`${API_URL}/w-item`, { code, count: 1, regosID: Number(this.metaData) }, { withCredentials: true });
        this.inputType = 'sku';
        this.code = code;
        await this.search();
        this.$toast.success(`1 ${code} added to Regos room`);
      } catch (error) {
        this.$toast.error(error.response.data || 'error while scanning the article');
      }
      this.loading = false;
    },
    incrementToOrder(article) {
      if (!this.inlineQ[article.codename]) {
        this.inlineQ[article.codename] = 0;
      }
      this.inlineQ[article.codename] += 1;
      this.inlineQ = { ...this.inlineQ };
    },
    decrementToOrder(article) {
      if (!this.inlineQ[article.codename]) return;
      this.inlineQ[article.codename] -= 1;
    },
    otkazi() {
      this.order = {};
    },
    printaj() {
      window.print();
    },
    getProductCode(codes) {
      for (let i = 0; i < codes.length; i += 1) {
        if (codes[i].type === 'manufacturer') return codes[i].code;
      }
      return '';
    },
    showImage(article) {
      // Product image
      this.articleDetails.image = article.images?.image ? article.images.image[0].url : null;
      // Link to bd web-shop
      this.articleDetails.link = article?.URL || null;

      // Product OEM numbers
      this.articleDetails.oems = []; // just so we remove if we have some from before
      const codes = article?.productCodes?.productCode;
      if (codes.length) {
        const OEMcodes = [];
        codes.forEach((c) => {
          if (c.abbreviation === 'OEM') OEMcodes.push(c.code);
        });

        if (OEMcodes.length) this.articleDetails.oems = OEMcodes.join(', ');
      }

      // If we don't have either of the two we don't open the modal
      if (!this.articleDetails.image && !this.articleDetails.oems.length) return;

      this.$refs['image-modal'].show();
    },
    toggleRegos() {
      this.isRegos = !this.isRegos;
      this.metaData = this.isRegos ? '' : 'WORKSHOP';
    },
    async adjustFavorite(product) {
      const userInput = prompt('How many of these would you like to set as favorite: '); // eslint-disable-line
      if (userInput === null) return;

      const parsedNumber = parseInt(userInput, 10);
      if (Number.isNaN(parsedNumber)) {
        this.$toast.error(`${userInput} is not a number!`);
        return;
      }

      this.loading = true;
      try {
        /* eslint-disable */
        await axios.put(`${API_URL}/favorite`, { id: product._id, count: parsedNumber}, { withCredentials: true });
        product.favorite = parsedNumber;
        /* eslint-enable */
        this.$toast.success(`${parsedNumber} is now recommended local count`);
      } catch (error) {
        this.$toast.error(error.response.data || 'error while adjusting favorites count');
      }
      this.loading = false;
    },
    favoriteLessThenLocal(a) {
      return (a.favorite && !a.localCount) || (a.localCount < a.favorite);
    },
    preventPaste() {
      const input = this.$refs.typeahead.$el.querySelector('input');
      if (input) {
        // Remove any existing paste event listeners first
        input.removeEventListener('paste', this.handlePaste);
        // Add the paste event listener
        input.addEventListener('paste', this.handlePaste);
      }
    },
    handlePaste(e) {
      e.preventDefault();
      e.stopPropagation();
    },
  },
};
</script>

<style>
  /*.title {*/
  /*  margin-top: 1rem;*/
  /*}*/
  /*.pretraga-container {*/
  /*  margin: 1rem 0;*/
  /*}*/

  .bg-yellow {
    border-bottom: yellow 6px solid;
  }

  /* Floating cart */
  .korpa {
    background-color: var(--surface) !important;
    border: 1px solid var(--border-strong) !important;
    box-shadow: var(--shadow-lg);
  }
  .korpa .list-group-item {
    background-color: var(--surface-2);
    color: var(--text);
  }
  .korpa .list-group-item input {
    background-color: transparent;
    color: var(--text);
    border-radius: var(--radius-sm);
  }
  .korpa .list-group-item input:focus {
    background-color: var(--surface-3);
    outline: none;
  }
  .remove-icon {
    cursor: pointer;
  }

  .hold-on {
    background-color: rgba(17, 18, 22, .85);
    position: absolute;
    z-index: 100;
    min-width: 100%;
    min-height: 100%;
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      opacity: 0.9;
    }
    50% {
      transform: scale(1.6);
      opacity: 1;
    }
  }

  .pulsing-number {
    display: inline-block;
    animation: pulse 2s infinite ease-in-out;
  }
</style>
